import { ConstructionOutlined } from "@mui/icons-material";
import Scenes from "oc-threejs/Scenes";
import Measurer from "../interaction/Measurer";
import FullHeightDragable from "./FullHeightDragable";
import Helper from "../model/Helper.js";

export default class Tuer extends FullHeightDragable {
  constructor(vsData) {
    super(vsData);
    // JVI: Ist kaum sichtbar.
    // Verhindert aber bei geschlossener Tür, dass dahinterliegende Interieur hovern.
    this.dragBox.position.z = 2;
    this.size={};   
  }

  onDragBegin() {
    super.onDragBegin();
    this.size.y = this.vsData.size.y;
    this.vsData.isDropped = false;
    APP.model.showDoorsClosed(true);
  }

  vsUpdate() {
    super.vsUpdate();
  }

  onDrop() {
    super.onDrop();
    this.vsData.size.y = this.vsData.element?.size.y < this.vsData.size.y ? this.size.y : this.vsData.size.y;
    this.vsData.isDropped = true;
  }

  onTap() {
    const interieurHoehe = this.vsData.frontBox.getSize().y;
    const interieurPosition = this.vsData.position.y;
    const interieurFreuraumUnten = this.vsData.product.FreiraumUnten;
    const interieurLaengeY = this.vsData.frontSize ? this.vsData.frontSize.y : interieurHoehe;
    const interieurUnterkante = this.vsData.frontBox ? this.vsData.localToSchrank(this.vsData.frontBox.min).y : this.vsData.box.min.y;
    const interieurOberkante = this.vsData.frontBox ? this.vsData.localToSchrank(this.vsData.frontBox.max).y : this.vsData.box.max.y;
    APP.uiHandler.dialog({
      title: I18N('dialogPositionTitle', this.vsData.product.Name),
      text: I18N('dialogPositionText',
          Helper.formatToRulerUnit(interieurHoehe), // %1$s,
          Helper.formatToRulerUnit(interieurPosition), // %2$s,
          Helper.formatToRulerUnit(interieurFreuraumUnten), // %3$s,
          Helper.formatToRulerUnit(interieurLaengeY), // %4$s,
          Helper.formatToRulerUnit(interieurUnterkante), // %5$s,
          Helper.formatToRulerUnit(interieurOberkante), // %6$s,
      ),
      buttons: [
        {
          style: 'primary',
          label: I18N('OK'),
          click: input => {
          }
        }
      ]
    });
  }

}
